// extracted by mini-css-extract-plugin
export var dividerLine = "_8u-3";
export var itemImage = "_8u-9";
export var lightDivider = "_8u-4";
export var modalContent = "_8u-5";
export var modalContentCompact = "_8u-6";
export var productCard = "_8u-a";
export var productImage = "_8u-b";
export var productImageCompact = "_8u-7";
export var productImagePlaceholder = "_8u-c";
export var productImagePlaceholderCompact = "_8u-8";
export var progressBarBackground = "_8u-1";
export var progressBarContainer = "_8u-0";
export var progressBarFill = "_8u-2";